<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <h3 class="card-title">Perfil Tributário</h3>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs v-model="tabIndex">
            <!-- ABA 1: PRINCIPAL -->
            <b-tab title="Principal">
              <b-row class="mt-3">
                <b-col md="8">
                  <b-form-group label="Descrição*">
                    <b-form-input
                      maxlength="150"
                      v-model="form.descricao"
                      placeholder="Ex: Produtos para venda ao consumidor final"
                      autofocus
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- NCM E CEST -->
              <b-row>
                <b-col md="3">
                  <b-form-group label="NCM">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="ncm"
                      @input="setNCM"
                      :options="ncms"
                      @search="onSearchNCM"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do NCM
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="CEST">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="cest"
                      @input="setCEST"
                      :options="cests"
                      @search="onSearchCEST"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do CEST
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- CFOPs -->
              <b-row>
                <b-col md="3">
                  <b-form-group label="CFOP NFe">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="cfop"
                      @input="setCFOP"
                      :options="cfops"
                      @search="onSearchCFOP"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do CFOP
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="CFOP NFce">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="cfop_nfce"
                      @input="setCFOPNFce"
                      :options="cfops_nfce"
                      @search="onSearchCFOPNfce"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do CFOP
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- CST/CSOSN -->
              <b-row>
                <b-col md="3">
                  <b-form-group label="CST/CSOSN Não Contribuinte">
                    <VueSelect
                      placeholder="Digite o código"
                      label="codigo"
                      v-model="cstcsosn"
                      @input="setCSTCSOSN"
                      :options="cstcsosns"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="CST/CSOSN Contribuinte">
                    <VueSelect
                      placeholder="Digite o código"
                      label="codigo"
                      v-model="cstcsosnContribuinte"
                      @input="setCSTCSOSNContribuinte"
                      :options="cstcsosns"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- TRIBUTAÇÕES -->
              <b-row>
                <b-col md="3">
                  <b-form-group label="Tributação">
                    <VueSelect
                      placeholder="Selecione a tributação"
                      label="descricao"
                      v-model="tributacao"
                      @input="setTributacao"
                      :options="tributacoes"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Nenhuma tributação disponível
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.descricao ? option.descricao.substring(0, 25) : "" }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Tributação ST">
                    <VueSelect
                      placeholder="Selecione a tributação ST"
                      label="descricao"
                      v-model="tributacaoST"
                      @input="setTributacaoST"
                      :options="tributacoes"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Nenhuma tributação disponível
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.descricao ? option.descricao.substring(0, 25) : "" }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- CAMPOS DE DIGITAR -->
              <b-row class="mt-4">
                <b-col md="2">
                  <b-form-group label="Origem">
                    <b-form-select v-model="form.id_origem">
                      <b-form-select-option :value="null">Selecione...</b-form-select-option>
                      <b-form-select-option
                        v-for="origem in origens"
                        :key="origem.id + 'origem'"
                        :value="origem.id"
                      >
                        {{ origem.descricao }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group id="mva" label-for="mva" label="% MVA">
                    <money
                      class="form-control"
                      v-model="form.mva"
                      v-bind="configMoney"
                    >
                    </money>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="2">
                  <b-form-group label="Código Benef.">
                    <b-form-input maxlength="15" v-model="form.codigo_beneficio" placeholder="Ex: 2100"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="2" v-if="tributacoes.length > 0">
                  <b-form-group label="FCP" label-for="form.id_fcp">
                    <VueSelect
                      label="descricao"
                      @input="setFCP"
                      v-model="fcp"
                      :options="tributacoes"
                      :clearable="true"
                    >
                      <template slot="no-options"> Informe a descricao </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{
                            option.descricao
                              ? option.descricao.substring(0, 20)
                              : ""
                          }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>

            <!-- ABA 2: PIS/COFINS/IPI -->
            <b-tab title="IPI/PIS/COFINS">
              <b-row class="mt-3">
                <b-col md="12">
                  <h5 class="text-dark font-weight-bold mb-3">PIS, COFINS e IPI</h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <b-form-group id="ipi" label-for="ipi" label="% IPI">
                    <money
                      class="form-control"
                      v-model="form.ipi"
                      v-bind="configMoney"
                    >
                    </money>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="CST IPI">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="cstipi"
                      @input="setCSTIPI"
                      :options="cstipis"
                      @search="onSearchCSTIPI"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do CST IPI
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group id="pis" label-for="pis" label="% PIS">
                    <money
                      class="form-control"
                      v-model="form.pis"
                      v-bind="configMoney"
                    >
                    </money>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="CST PIS">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="cstpis"
                      @input="setCSTPIS"
                      :options="cstspis"
                      @search="onSearchCSTPIS"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do CST PIS
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group id="cofins" label-for="cofins" label="% COFINS">
                    <money
                      class="form-control"
                      v-model="form.cofins"
                      v-bind="configMoney"
                    >
                    </money>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="CST COFINS">
                    <VueSelect
                      placeholder="Digite para pesquisar"
                      :filterable="false"
                      v-model="cstcofins"
                      @input="setCSTCOFINS"
                      :options="cstscofins"
                      @search="onSearchCSTCOFINS"
                      :clearable="true"
                    >
                      <template slot="no-options">
                        Informe o código do CST COFINS
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.codigo }} - {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.codigo }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>

            <!-- ABA 3: REFORMA TRIBUTÁRIA -->
            <b-tab title="Reforma Tributária">
              <b-row>
              <b-card class="mb-3">
                <!-- Aviso -->
                <div class="mb-3">
                  <div class="font-weight-bold">Atenção!</div>
                  <small class="text-muted">
                    Estamos acompanhando de perto as mudanças da Reforma Tributária e para deixar essa transição
                    mais simples e transparente pra você, incluímos abaixo alguns campos que simulam a nova
                    tributação (IBS/CBS/IS). Esses dados são orientativos e podem mudar conforme novas definições
                    legais forem publicadas.
                  </small>
                </div>

                <!-- Linha 1 -->
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Class. trib. IBS/CBS.">
                      <b-form-select
                        v-model="form.class_trib_ibs_cbs"
                        :options="optionsClassTribIbsCbsFiltered"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="CST IBS/CBS">
                      <b-form-select v-model="form.cst_ibs_cbs" :options="optionsCstIbsCbsArr" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Class. trib. regular">
                      <b-form-select v-model="form.class_trib_regular" :options="optionsClassTribRegularFiltered" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="CST regular">
                      <b-form-select v-model="form.cst_regular" :options="optionsCstRegular" />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Linha 2 -->
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Cod. créd. Presumido">
                      <b-form-select v-model="form.cod_cred_presumido" :options="optionsCodCredPresumido" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3" class="d-flex align-items-end">
                    <b-form-group label="Ind. bem móvel usado" class="mb-0">
                      <b-form-checkbox v-model="form.ind_bem_movel_usado" switch />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- IBS -->
                <div class="mt-3 mb-2 text-muted font-weight-bold">IBS - Imposto sobre Bens e Serviços</div>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="% Redução base Mun.">
                      <money class="form-control" v-model="form.ibs_reducao_mun" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Aliq efetiva Mun.">
                      <money class="form-control" v-model="form.ibs_aliquota_efetiva_mu" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Redução base UF">
                      <money class="form-control" v-model="form.ibs_reducao_uf" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Aliq efetiva UF.">
                      <money class="form-control" v-model="form.ibs_aliquota_efetiva_uf" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>


                  <b-col md="3">
                    <b-form-group label="% Diferimento Mun.">
                      <money class="form-control" v-model="form.ibs_diferimento_mun" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Diferimento UF">
                      <money class="form-control" v-model="form.ibs_diferimento_uf" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- CBS -->
                <div class="mt-2 mb-2 text-muted font-weight-bold">CBS - Contribuição sobre Bens e Serviços</div>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="% Diferimento">
                      <money class="form-control" v-model="form.cbs_diferimento" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Redução">
                      <money class="form-control" v-model="form.cbs_reducao" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Aliq. efetiva CBS">
                      <money class="form-control" v-model="form.cbs_aliq_cred_presumido" v-bind="configMoney" />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- IS -->
                <div class="mt-2 mb-2 text-muted font-weight-bold">IS - Imposto Seletivo</div>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="CST IS">
                      <b-form-select :disabled="true" v-model="form.cst_is" :options="optionsCstIs" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Class. trib. IS">
                      <b-form-select :disabled="true" v-model="form.class_trib_is" :options="optionsClassTribIs" />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Alíquota específica">
                      <money
                        class="form-control"
                        :disabled="true"
                        v-model="form.aliquota_especifica_is"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Alíquota IS">
                      <money
                        class="form-control"
                        :disabled="true"
                        v-model="form.aliquota_is"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <Loader v-if="loading" />
          <button
            type="submit"
            class="btn btn-primary mr-2"
            :disabled="loading"
          >
            <i v-if="!loading" class="fa fa-save"></i>
            Salvar
          </button>
          <router-link
            to="/perfilTributario"
            class="btn btn-secondary ml-2"
          >
            Cancelar
          </router-link>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/Loader/Loader";
import VueSelect from "vue-select";
import { SistemaMixin } from "@/modules/Application";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import _ from "lodash";

const optionsClassTribIbsCbs = [
  {
    "value": "000001",
    "text": "000001 - Situações tributadas integralmente pelo IBS e CBS.",
    "cst": "000"
  },
  {
    "value": "000002",
    "text": "000002 - Exploração de via",
    "cst": "000"
  },
  {
    "value": "000003",
    "text": "000003 - Regime automotivo - projetos incentivados (art. 311)",
    "cst": "000"
  },
  {
    "value": "000004",
    "text": "000004 - Regime automotivo - projetos incentivados (art. 312)",
    "cst": "000"
  },
  {
    "value": "010001",
    "text": "010001 - Operações do FGTS não realizadas pela Caixa Econômica Federal",
    "cst": "010"
  },
  {
    "value": "010002",
    "text": "010002 - Operações do serviço financeiro",
    "cst": "010"
  },
  {
    "value": "011001",
    "text": "011001 - Planos de assistência funerária.",
    "cst": "011"
  },
  {
    "value": "011002",
    "text": "011002 - Planos de assistência à saúde",
    "cst": "011"
  },
  {
    "value": "011003",
    "text": "011003 - Intermediação de planos de assistência à saúde",
    "cst": "011"
  },
  {
    "value": "011004",
    "text": "011004 - Concursos e prognósticos",
    "cst": "011"
  },
  {
    "value": "011005",
    "text": "011005 - Planos de assistência à saúde de animais domésticos",
    "cst": "011"
  },
  {
    "value": "200001",
    "text": "200001 - Aquisições realizadas entre empresas autorizadas a operar em zonas de processamento de exportação",
    "cst": "200"
  },
  {
    "value": "200002",
    "text": "200002 - Fornecimento ou importação para produtor rural não contribuinte ou TAC",
    "cst": "200"
  },
  {
    "value": "200003",
    "text": "200003 - Vendas de produtos destinados à alimentação humana (Anexo I)",
    "cst": "200"
  },
  {
    "value": "200004",
    "text": "200004 - Venda de dispositivos médicos (Anexo XII)",
    "cst": "200"
  },
  {
    "value": "200005",
    "text": "200005 - Venda de dispositivos médicos adquiridos por órgãos da administração pública (Anexo IV)",
    "cst": "200"
  },
  {
    "value": "200006",
    "text": "200006 - Venda de livros, e-books, incluindo periódicos, jornais, revistas e publicações similares",
    "cst": "200"
  },
  {
    "value": "220001",
    "text": "220001 - Operações com alíquota fixa",
    "cst": "220"
  },
  {
    "value": "221001",
    "text": "221001 - Venda de energia elétrica",
    "cst": "221"
  },
  {
    "value": "400001",
    "text": "400001 - Operações isentas",
    "cst": "400"
  },
  {
    "value": "410001",
    "text": "410001 - Operações imunes",
    "cst": "410"
  }
];

const optionsCstIbsCbs = [
  { value: "", text: "-- Selecione uma opção --" },
  { value: "000", text: "000 - Tributação integral" },
  { value: "010", text: "010 - Tributação com alíquotas uniformes" },
  { value: "011", text: "011 - Tributação com alíquotas uniformes reduzidas" },
  { value: "200", text: "200 - Alíquota reduzida" },
  { value: "220", text: "220 - Alíquota fixa" },
  { value: "221", text: "221 - Alíquota fixa proporcional" },
  { value: "222", text: "222 - Redução de Base de Cálculo" },
  { value: "400", text: "400 - Isenção" },
  { value: "410", text: "410 - Imunidade e não incidência" },
  { value: "510", text: "510 - Diferimento" },
  { value: "515", text: "515 - Diferimento com redução de alíquota" },
  { value: "550", text: "550 - Suspensão" },
  { value: "620", text: "620 - Tributação Monofásica" },
  { value: "800", text: "800 - Transferência de crédito" },
  { value: "810", text: "810 - Ajuste de IBS na ZFM" },
  { value: "811", text: "811 - Ajustes" },
  { value: "820", text: "820 - Tributação em declaração de regime específico" },
  { value: "830", text: "830 - Exclusão da Base de Cálculo" },
];

const optionsCredPresumido = [
  { value: null, text: "-- Selecione uma opção --" },
  {
    value: "01",
    text:
      "01 - Crédito presumido da aquisição de bens e serviços de produtor rural e produtor rural integrado não contribuinte, observado o art. 168 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "02",
    text:
      "02 - Crédito presumido da aquisição de serviço de transportador autônomo de carga pessoa física não contribuinte, observado o art. 169 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "03",
    text:
      "03 - Crédito presumido da aquisição de resíduos e demais materiais destinados à reciclagem, reutilização ou logística reversa adquiridos de pessoa física, cooperativa ou outra forma de organização popular, observado o art. 170 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "04",
    text:
      "04 - Crédito presumido da aquisição de bens móveis usados de pessoa física não contribuinte para revenda, observado o art. 171 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "05",
    text:
      "05 - Crédito presumido no regime automotivo, observado o art. 311 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "06",
    text:
      "06 - Crédito presumido no regime automotivo, observado o art. 312 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "07",
    text:
      "07 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 444 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "08",
    text:
      "08 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "09",
    text:
      "09 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 449 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "10",
    text:
      "10 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 450 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "11",
    text:
      "11 - Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 462 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "12",
    text:
      "12 - Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 465 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "13",
    text:
      "13 - Crédito presumido na aquisição pela indústria na Área de Livre Comércio, observado o art. 467 da Lei Complementar nº 214, de 2025.",
  },
];

const optionsClassTribBase = optionsClassTribIbsCbs;
const optionsCstBase = optionsCstIbsCbs;

export default {
  name: "app-perfil-tributario-form",
  components: {
    Loader,
    VueSelect,
    Money,
  },
  mixins: [SistemaMixin],
  props: {
    url: {
      type: String,
      required: true,
    },
    perfilTributario: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        id: null,
        descricao: "",
        id_ncm: null,
        id_cest: null,
        id_cfop: null,
        id_cst_csosn: null,
        id_cst_csosn_contribuinte: null,
        ipi: 0,
        pis: 0,
        cofins: 0,
        id_tributacao: null,
        id_tributacao_st: null,
        id_cenq: null,
        id_cstipi: null,
        id_cstpis: null,
        mva: 0,
        id_fcp: null,
        excecaoFiscal: null,
        id_anp: null,
        id_cstcofins: null,
        id_cfop_nfce: null,
        codigo_beneficio: null,
        id_origem: 0,
        class_trib_ibs_cbs: null,
        cst_ibs_cbs: null,
        class_trib_regular: null,
        cst_regular: null,
        cod_cred_presumido: null,
        ind_bem_movel_usado: false,
        ibs_diferimento_mun: 0,
        ibs_reducao_mun: 0,
        ibs_aliquota_efetiva_mu: 0,
        ibs_reducao_uf: 0,
        ibs_aliquota_efetiva_uf: 0,
        ibs_diferimento_uf: 0,
        ibs_aliq_cred_presumido: 0,
        cbs_diferimento: 0,
        cbs_reducao: 0,
        cbs_aliq_cred_presumido: 0,
        cst_is: null,
        class_trib_is: null,
        aliquota_especifica_is: 0,
        aliquota_is: 0,
      },
      loading: false,
      tabIndex: 0,
      configMoney: settingMoney,
      // Campos com busca
      cfop: null,
      cfops: [],
      cfop_nfce: null,
      cfops_nfce: [],
      cest: null,
      cests: [],
      ncm: null,
      ncms: [],
      tributacao: null,
      tributacaoST: null,
      tributacoes: [],
      cstcsosn: null,
      cstcsosnContribuinte: null,
      cstcsosns: [],
      cstipi: null,
      cstipis: [],
      cstpis: null,
      cstspis: [],
      cstcofins: null,
      cstscofins: [],
      optionsCstIs: [],
      optionsClassTribIs: [],
      optionsCstIbsCbsArr: optionsCstIbsCbs,
      optionsCstRegular: optionsCstBase,
      optionsCodCredPresumido: optionsCredPresumido,
      origens: [
        {
          id: 0,
          descricao: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
        },
        {
          id: 1,
          descricao:
            "1 - Estrangeira - Importação direta, exceto a indicada no código 6",
        },
        {
          id: 2,
          descricao:
            "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
        },
        {
          id: 3,
          descricao:
            "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%",
        },
        {
          id: 4,
          descricao:
            "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967.",
        },
        {
          id: 5,
          descricao:
            "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
        },
        {
          id: 6,
          descricao:
            "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 7,
          descricao:
            "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 8,
          descricao:
            "8 – Nacional: mercadoria ou bem com Conteúdo de Importação superior a 70%;",
        },
      ],
    };
  },
  validations: {},
  computed: {
    ...mapGetters(["userAccess"]),
    optionsClassTribIbsCbsFiltered() {
      const cst = this.form.cst_ibs_cbs
        ? String(this.form.cst_ibs_cbs).padStart(3, "0")
        : "";

      const list = cst
        ? optionsClassTribIbsCbs.filter(i => i.cst === cst)
        : optionsClassTribIbsCbs;

      return [
        { value: "", text: "-- Selecione uma opção --" },
        ...list.map(i => ({ value: i.value, text: i.text })),
      ];
    },
    optionsClassTribRegularFiltered() {
      const cst = this.form.cst_regular == null
        ? null
        : String(this.form.cst_regular).padStart(3, "0");

      const list = cst
        ? optionsClassTribBase.filter(i => i.cst === cst)
        : optionsClassTribBase;

      return [
        { value: "", text: "-- Selecione uma opção --" },
        ...list.map(i => ({ value: i.value, text: i.text })),
      ];
    },
  },
  watch: {
    "form.class_trib_ibs_cbs"(val) {
      if (!val) {
        this.form.cst_ibs_cbs = "";
        return;
      }

      const found = optionsClassTribIbsCbs.find(i => i.value === val);
      this.form.cst_ibs_cbs = found?.cst ?? "";
    },
    "form.cst_ibs_cbs"(val) {
      if (!val) return;
      const s = String(val).padStart(3, "0");
      if (s !== val) this.form.cst_ibs_cbs = s;
    },
    "form.class_trib_regular"(val) {
      if (!val) {
        this.form.cst_regular = null;
        return;
      }

      const found = optionsClassTribBase.find(i => i.value === val);
      this.form.cst_regular = found?.cst ?? null;
    },
    "form.cst_regular"(val) {
      if (val == null || val === "") return;

      const s = String(val).padStart(3, "0");
      if (s !== val) this.form.cst_regular = s;
    },
  },
  methods: {
    // Setters para VueSelect
    setCFOP(cfop) {
      if (cfop) {
        this.form.id_cfop = typeof cfop === 'object' ? cfop.id_cfop : cfop;
      }
      this.cfop = cfop;
    },
    setCEST(cest) {
      if (cest) {
        this.form.id_cest = typeof cest === 'object' ? cest.id_cest : cest;
      }
      this.cest = cest;
    },
    setNCM(ncm) {
      if (ncm) {
        this.form.id_ncm = typeof ncm === 'object' ? ncm.id_ncm : ncm;
      }
      this.ncm = ncm;
    },

    // Handlers de busca
    onSearchCFOP(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOP(loading, search, this);
      }
    },
    searchCFOP: _.debounce(async (loading, search, vm) => {
      vm.cfops = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),

    onSearchCEST(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCEST(loading, search, this);
      }
    },
    searchCEST: _.debounce(async (loading, search, vm) => {
      vm.cests = await vm.getCstCest(search);
      loading(false);
    }, 350),

    onSearchNCM(search, loading) {
      if (search.length) {
        loading(true);
        this.searchNCM(loading, search, this);
      }
    },
    searchNCM: _.debounce(async (loading, search, vm) => {
      vm.ncms = await vm.getNCM(search);
      loading(false);
    }, 350),

    async setCFOPNFce(cfop_nfce) {
      if (!cfop_nfce) {
        this.cfop_nfce = null;
        this.form.id_cfop_nfce = null;
        return;
      }
      
      if (typeof cfop_nfce === 'object') {
        // Tenta extrair id de diferentes propriedades
        const idValue = cfop_nfce.id_cfop || cfop_nfce.id;
        if (idValue) {
          this.form.id_cfop_nfce = idValue;
          this.cfop_nfce = cfop_nfce;
          return;
        }
      }
      
      if (typeof cfop_nfce === 'string' || typeof cfop_nfce === 'number') {
        const cfops_nfce = await this.getCFOPByCodigo(String(cfop_nfce));
        if (cfops_nfce && cfops_nfce.length > 0) {
          this.cfop_nfce = cfops_nfce[0];
          this.form.id_cfop_nfce = cfops_nfce[0].id_cfop || cfops_nfce[0].id;
        }
      }
    },

    onSearchCFOPNfce(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOPNfce(loading, search, this);
      }
    },
    searchCFOPNfce: _.debounce(async (loading, search, vm) => {
      vm.cfops_nfce = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),

    setTributacao(tributacao) {
      if (tributacao) {
        this.form.id_tributacao = typeof tributacao === 'object' ? tributacao.id : tributacao;
      }
      this.tributacao = tributacao;
    },

    setTributacaoST(tributacaoST) {
      if (tributacaoST) {
        this.form.id_tributacao_st = typeof tributacaoST === 'object' ? tributacaoST.id : tributacaoST;
      }
      this.tributacaoST = tributacaoST;
    },

    setCSTCSOSN(cstcsosn) {
      if (cstcsosn) {
        this.form.id_cst_csosn = typeof cstcsosn === 'object' ? cstcsosn.id_cst_csosn : cstcsosn;
      }
      this.cstcsosn = cstcsosn;
    },

    setCSTCSOSNContribuinte(cstcsosnContribuinte) {
      if (cstcsosnContribuinte) {
        // Tenta cobrir diferentes nomes de propriedade
        const idValue = 
          (typeof cstcsosnContribuinte === 'object') ? 
            (cstcsosnContribuinte.id_cst_csosn_contribuinte || 
             cstcsosnContribuinte.id_cst_csosn || 
             cstcsosnContribuinte.id) 
          : cstcsosnContribuinte;
        
        this.form.id_cst_csosn_contribuinte = idValue;
      }
      this.cstcsosnContribuinte = cstcsosnContribuinte;
    },

    setFCP(fcp) {
      if (fcp) {
        this.form.id_fcp = typeof fcp === 'object' ? fcp.id : fcp;
      }
      this.fcp = fcp;
    },

    setCSTIPI(cstipi) {
      if (cstipi) {
        this.form.id_cstipi = typeof cstipi === 'object' ? cstipi.id_cstipi : cstipi;
      }
      this.cstipi = cstipi;
    },

    onSearchCSTIPI(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCSTIPI(loading, search, this);
      }
    },
    searchCSTIPI: _.debounce(async (loading, search, vm) => {
      vm.cstipis = await vm.getCSTIPIByCodigo(search);
      loading(false);
    }, 350),

    setCSTPIS(cstpis) {
      if (cstpis) {
        this.form.id_cstpis = typeof cstpis === 'object' ? cstpis.id_cstpis : cstpis;
      }
      this.cstpis = cstpis;
    },

    onSearchCSTPIS(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCSTPIS(loading, search, this);
      }
    },
    searchCSTPIS: _.debounce(async (loading, search, vm) => {
      vm.cstspis = await vm.getCSTPISByCodigo(search);
      loading(false);
    }, 350),

    setCSTCOFINS(cstcofins) {
      if (cstcofins) {
        this.form.id_cstcofins = typeof cstcofins === 'object' ? cstcofins.id_cstcofins : cstcofins;
      }
      this.cstcofins = cstcofins;
    },

    onSearchCSTCOFINS(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCSTCOFINS(loading, search, this);
      }
    },
    searchCSTCOFINS: _.debounce(async (loading, search, vm) => {
      vm.cstscofins = await vm.getCSTCofinsByCodigo(search);
      loading(false);
    }, 350),

    async onSubmit() {
      this.loading = true;

      try {
        // Prepara os dados para envio - copia apenas os campos necessários
        const payload = {
          id: this.form.id,
          descricao: this.form.descricao,
          id_ncm: this.form.id_ncm,
          id_cest: this.form.id_cest,
          id_cfop: this.form.id_cfop,
          id_cfop_nfce: this.form.id_cfop_nfce,
          id_cst_csosn: this.form.id_cst_csosn,
          id_cst_csosn_contribuinte: this.form.id_cst_csosn_contribuinte,
          id_tributacao: this.form.id_tributacao,
          id_tributacao_st: this.form.id_tributacao_st,
          ipi: this.form.ipi,
          pis: this.form.pis,
          cofins: this.form.cofins,
          id_cstipi: this.form.id_cstipi,
          id_cstpis: this.form.id_cstpis,
          id_cstcofins: this.form.id_cstcofins,
          mva: this.form.mva,
          id_fcp: this.form.id_fcp ? parseInt(this.form.id_fcp, 10) : null,
          excecaoFiscal: this.form.excecaoFiscal,
          id_anp: this.form.id_anp,
          id_cenq: this.form.id_cenq,
          id_origem: this.form.id_origem,
          codigo_beneficio: this.form.codigo_beneficio,
          class_trib_ibs_cbs: this.form.class_trib_ibs_cbs,
          cst_ibs_cbs: this.form.cst_ibs_cbs,
          class_trib_regular: this.form.class_trib_regular,
          cst_regular: this.form.cst_regular,
          cod_cred_presumido: this.form.cod_cred_presumido,
          ind_bem_movel_usado: this.form.ind_bem_movel_usado,
          ibs_diferimento_mun: this.form.ibs_diferimento_mun,
          ibs_reducao_mun: this.form.ibs_reducao_mun,
          ibs_aliquota_efetiva_mu: this.form.ibs_aliquota_efetiva_mu,
          ibs_reducao_uf: this.form.ibs_reducao_uf,
          ibs_aliquota_efetiva_uf: this.form.ibs_aliquota_efetiva_uf,
          ibs_diferimento_uf: this.form.ibs_diferimento_uf,
          ibs_aliq_cred_presumido: this.form.ibs_aliq_cred_presumido,
          cbs_diferimento: this.form.cbs_diferimento,
          cbs_reducao: this.form.cbs_reducao,
          cbs_aliq_cred_presumido: this.form.cbs_aliq_cred_presumido,
          cst_is: this.form.cst_is,
          class_trib_is: this.form.class_trib_is,
          aliquota_is: this.form.aliquota_is,
          aliquota_especifica_is: this.form.aliquota_especifica_is,
        };

        // Atualiza IDs a partir dos VueSelects se disponível
        if (this.cfop) payload.id_cfop = this.cfop.id_cfop;
        if (this.cest) payload.id_cest = this.cest.id_cest;
        if (this.ncm) payload.id_ncm = this.ncm.id_ncm;
        if (this.cfop_nfce) payload.id_cfop_nfce = this.cfop_nfce.id_cfop;
        if (this.tributacao) payload.id_tributacao = this.tributacao.id;
        if (this.tributacaoST) payload.id_tributacao_st = this.tributacaoST.id;
        if (this.cstcsosn) payload.id_cst_csosn = this.cstcsosn.id_cst_csosn;
        
        // CST CSOSN Contribuinte - tenta cobrir diferentes nomes de propriedade
        if (this.cstcsosnContribuinte) {
          payload.id_cst_csosn_contribuinte = 
            this.cstcsosnContribuinte.id_cst_csosn_contribuinte || 
            this.cstcsosnContribuinte.id_cst_csosn ||
            this.cstcsosnContribuinte.id;
        }
        
        if (this.cstipi) payload.id_cstipi = this.cstipi.id_cstipi;
        if (this.cstpis) payload.id_cstpis = this.cstpis.id_cstpis;
        if (this.cstcofins) payload.id_cstcofins = this.cstcofins.id_cstcofins;
        if (this.fcp) payload.id_fcp = parseInt(this.fcp.id, 10);

        console.log("Payload enviado:", payload);

        const response = await this.$http.post(this.url, payload);
        const data = response.data;

        console.log("Response from save:", response);
        console.log("Response data:", data);
        console.log("Response status:", response.status);

        // Se a requisição completou (status 200), considera sucesso mesmo que não retorne dados
        if (response.status === 200) {
          this.$toast.success((data && data.message) || "Registro armazenado com sucesso!");
          setTimeout(() => {
            this.$router.push({ name: "perfilTributarioLista" });
          }, 1000);
        } else if (data && (data.status === true || data.success === true)) {
          this.$toast.success(data.message || "Registro armazenado com sucesso!");
          setTimeout(() => {
            this.$router.push({ name: "perfilTributarioLista" });
          }, 1000);
        } else {
          const errorMsg = (data && data.message) || "Erro ao salvar registro!";
          this.$toast.error(errorMsg);
          console.warn("Response without success status:", data);
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Erro ao processar requisição!");
        console.error("Error saving perfil tributario:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    // Carrega os dados iniciais dos dropdowns
    this.getCstCsosn().then((data) => (this.cstcsosns = data));
    this.getTributacao().then((data) => (this.tributacoes = data));
    this.getCSTPISByCodigo().then((data) => (this.cstspis = data));
    this.getCSTCofinsByCodigo().then((data) => (this.cstscofins = data));

    if (this.perfilTributario && this.perfilTributario.id) {
      console.log("=== CARREGANDO PERFIL TRIBUTÁRIO ===");
      console.log("Dados do perfil recebidos:", this.perfilTributario);
      
      // Copia APENAS os campos essenciais, não os objetos relacionados
      this.form.id = this.perfilTributario.id;
      this.form.descricao = this.perfilTributario.descricao;
      this.form.id_ncm = this.perfilTributario.id_ncm;
      this.form.id_cest = this.perfilTributario.id_cest;
      this.form.id_cfop = this.perfilTributario.id_cfop;
      this.form.id_cfop_nfce = this.perfilTributario.id_cfop_nfce;
      this.form.id_cst_csosn = this.perfilTributario.id_cst_csosn;
      this.form.id_cst_csosn_contribuinte = this.perfilTributario.id_cst_csosn_contribuinte;
      this.form.id_tributacao = this.perfilTributario.id_tributacao;
      this.form.id_tributacao_st = this.perfilTributario.id_tributacao_st;
      this.form.ipi = this.perfilTributario.ipi;
      this.form.pis = this.perfilTributario.pis;
      this.form.cofins = this.perfilTributario.cofins;
      this.form.id_cstipi = this.perfilTributario.id_cstipi;
      this.form.id_cstpis = this.perfilTributario.id_cstpis;
      this.form.id_cstcofins = this.perfilTributario.id_cstcofins;
      this.form.mva = this.perfilTributario.mva;
      this.form.id_fcp = this.perfilTributario.id_fcp;
      this.form.excecaoFiscal = this.perfilTributario.excecaoFiscal;
      this.form.id_anp = this.perfilTributario.id_anp;
      this.form.id_cenq = this.perfilTributario.id_cenq;
      this.form.id_origem = this.perfilTributario.id_origem;
      this.form.codigo_beneficio = this.perfilTributario.codigo_beneficio;
      this.form.class_trib_ibs_cbs = this.perfilTributario.class_trib_ibs_cbs;
      this.form.cst_ibs_cbs = this.perfilTributario.cst_ibs_cbs;
      this.form.class_trib_regular = this.perfilTributario.class_trib_regular;
      this.form.cst_regular = this.perfilTributario.cst_regular;
      this.form.cod_cred_presumido = this.perfilTributario.cod_cred_presumido;
      this.form.ind_bem_movel_usado = this.perfilTributario.ind_bem_movel_usado;
      this.form.ibs_diferimento_mun = this.perfilTributario.ibs_diferimento_mun;
      this.form.ibs_reducao_mun = this.perfilTributario.ibs_reducao_mun;
      this.form.ibs_aliquota_efetiva_mu = this.perfilTributario.ibs_aliquota_efetiva_mu;
      this.form.ibs_reducao_uf = this.perfilTributario.ibs_reducao_uf;
      this.form.ibs_aliquota_efetiva_uf = this.perfilTributario.ibs_aliquota_efetiva_uf;
      this.form.ibs_diferimento_uf = this.perfilTributario.ibs_diferimento_uf;
      this.form.ibs_aliq_cred_presumido = this.perfilTributario.ibs_aliq_cred_presumido;
      this.form.cbs_diferimento = this.perfilTributario.cbs_diferimento;
      this.form.cbs_reducao = this.perfilTributario.cbs_reducao;
      this.form.cbs_aliq_cred_presumido = this.perfilTributario.cbs_aliq_cred_presumido;
      this.form.cst_is = this.perfilTributario.cst_is;
      this.form.class_trib_is = this.perfilTributario.class_trib_is;
      this.form.aliquota_is = this.perfilTributario.aliquota_is;
      this.form.aliquota_especifica_is = this.perfilTributario.aliquota_especifica_is;
      
      // Carrega os dados dos VueSelect apenas para exibição
      console.log("Carregando CFOP:", this.perfilTributario.cfop);
      this.setCFOP(this.perfilTributario.cfop);
      
      console.log("Carregando CEST:", this.perfilTributario.cest);
      this.setCEST(this.perfilTributario.cest);
      
      console.log("Carregando NCM:", this.perfilTributario.ncm);
      this.setNCM(this.perfilTributario.ncm);
      
      console.log("Carregando CFOP NFCe:", this.perfilTributario.cfop_nfce);
      this.setCFOPNFce(this.perfilTributario.cfop_nfce);
      
      console.log("Carregando Tributação:", this.perfilTributario.tributacao);
      this.setTributacao(this.perfilTributario.tributacao);
      
      console.log("Carregando Tributação ST:", this.perfilTributario.tributacao_st);
      this.setTributacaoST(this.perfilTributario.tributacao_st);
      
      console.log("Carregando CST CSOSN:", this.perfilTributario.cst_csosn);
      this.setCSTCSOSN(this.perfilTributario.cst_csosn);
      
      console.log("Carregando CST CSOSN Contribuinte:", this.perfilTributario.cst_csosn_contribuinte);
      this.setCSTCSOSNContribuinte(this.perfilTributario.cst_csosn_contribuinte);
      
      console.log("Carregando CST IPI:", this.perfilTributario.cst_ipi);
      this.setCSTIPI(this.perfilTributario.cst_ipi);
      
      console.log("Carregando CST PIS:", this.perfilTributario.cst_pis);
      this.setCSTPIS(this.perfilTributario.cst_pis);
      
      console.log("Carregando CST COFINS:", this.perfilTributario.cst_cofins);
      this.setCSTCOFINS(this.perfilTributario.cst_cofins);
      
      console.log("Carregando FCP:", this.perfilTributario.fcp);
      this.setFCP(this.perfilTributario.fcp);
      
      console.log("=== PERFIL CARREGADO COM SUCESSO ===");
    }
  },
};
</script>

<style scoped>
.d-center {
  display: flex;
  align-items: center;
}

.selected {
  color: #333;
}
</style>
